module.exports = __webpack_public_path__ + "img/badge-most-conversion-gold.a0b147f2.png";